import { render, staticRenderFns } from "./recordingVideoModal.vue?vue&type=template&id=388fe5de&scoped=true&"
import script from "./recordingVideoModal.vue?vue&type=script&lang=js&"
export * from "./recordingVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./recordingVideoModal.vue?vue&type=style&index=0&id=388fe5de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388fe5de",
  null
  
)

export default component.exports